import { createHashRouter, Navigate } from 'react-router';
import { AuthLayout } from './components/layout/AuthLayout';
import { LoginPage } from './pages/auth/LoginPage';
import { DashboardPage } from './pages/DashboardPage';
import { NewEstimatePage } from './pages/estimates/NewEstimatePage';
import { NewCustomEstimatePage } from './pages/estimates/NewCustomEstimatePage';
import { EstimatesPage } from './pages/estimates/EstimatesPage';
import { EstimateDetailPage } from './pages/estimates/EstimateDetailPage';
import { ActualBillPage } from './pages/estimates/ActualBillPage';
import { ProceduresPage } from './pages/admin/ProceduresPage';
import { CostConfigPage } from './pages/admin/CostConfigPage';
import { PricingPage } from './pages/admin/PricingPage';
import { RoomTypesPage } from './pages/admin/RoomTypesPage';
import { IcuRatesPage } from './pages/admin/IcuRatesPage';
import { UsersPage } from './pages/admin/UsersPage';
import { SettingsPage } from './pages/admin/SettingsPage';
import { DoctorsPage } from './pages/admin/DoctorsPage';

export const router = createHashRouter([
    {
        path: '/login',
        element: <LoginPage />,
    },
    {
        path: '/',
        element: <AuthLayout />,
        children: [
            {
                index: true,
                element: <Navigate to="/dashboard" replace />,
            },
            {
                path: 'dashboard',
                element: <DashboardPage />,
            },
            {
                path: 'estimates',
                element: <EstimatesPage />,
            },
            {
                path: 'estimates/new',
                element: <NewEstimatePage />,
            },
            {
                path: 'estimates/custom',
                element: <NewCustomEstimatePage />,
            },
            {
                path: 'estimates/:id',
                element: <EstimateDetailPage />,
            },
            {
                path: 'estimates/:id/actual',
                element: <ActualBillPage />,
            },
            // Admin routes
            {
                path: 'admin/procedures',
                element: <ProceduresPage />,
            },
            {
                path: 'admin/cost-config',
                element: <CostConfigPage />,
            },
            {
                path: 'admin/doctors',
                element: <DoctorsPage />,
            },
            {
                path: 'admin/pricing',
                element: <PricingPage />,
            },
            {
                path: 'admin/room-types',
                element: <RoomTypesPage />,
            },
            {
                path: 'admin/icu-rates',
                element: <IcuRatesPage />,
            },
            {
                path: 'admin/users',
                element: <UsersPage />,
            },
            {
                path: 'admin/settings',
                element: <SettingsPage />,
            },
        ],
    },
]);
